import React from 'react';

import { Button, Modal } from 'antd';

import { BLINKET_EVENT_URL } from 'settings';

interface IProps {
  open: boolean;
  onClose: () => void;
  saleUrl: string;
}

const DraftPreview = ({ open, onClose, saleUrl }: IProps) => {
  const [reloadKey, setReloadKey] = React.useState(Date.now());
  const url = `${BLINKET_EVENT_URL}/${saleUrl}?preview=1&draft=1`;

  React.useEffect(() => {
    if (open) {
      setReloadKey(Date.now());
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={1200}
      centered
      closable={false}
      footer={
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button type='primary' onClick={onClose}>
            Fechar
          </Button>
        </div>
      }
    >
      <iframe
        key={reloadKey}
        id='event-page-preview'
        title='event-page-preview'
        src={url}
        style={{ height: '600px', width: '100%' }}
        frameBorder='0'
      />
    </Modal>
  );
};

export default DraftPreview;
